import { extendDefaultFacetList } from 'bundles/search-common/components/filters/getFacets';
import { DEFAULT_SEARCH_FACETS } from 'bundles/search-common/constants/filter';
import { useShowCourseraTier } from 'bundles/search-common/providers/LearnerProvider';

/**
 * Custom hook that returns an ordered array of facet keys based on configuration.
 *
 * This hook determines the order and inclusion of search facets based on various
 * conditions like Coursera Plus availability.
 *
 * @param customDefaults - Optional custom default facet order. If not provided, uses DEFAULT_SEARCH_FACETS
 * @returns Array of facet keys in the appropriate order with conditional additions
 *
 * @example
 * const facetOrder = useFacetOrder();
 *
 * @example
 * const customFacetOrder = useFacetOrder(['topic', 'language', 'partners']);
 */
const useFacetOrder = (customDefaults?: string[]) => {
  const shouldShowCourseraPlusFilter = useShowCourseraTier();
  const defaultList = customDefaults || DEFAULT_SEARCH_FACETS;
  return extendDefaultFacetList(defaultList, shouldShowCourseraPlusFilter);
};

export default useFacetOrder;
